import { sameOrigin } from "@/utils/same_origin";
import { router, usePage } from "@inertiajs/react";

type PageProps = {
  referrer: string;
};

const useGoBack = () => {
  const { referrer } = usePage<PageProps>().props;

  return () => {
    if (referrer && sameOrigin(referrer)) {
      router.visit(referrer);
    } else {
      router.visit("/");
    }
  };
};

export default useGoBack;
